
// import { Bell, Search, Globe, ChevronDown } from "lucide-react";

// export default function Header({ userName = "Arjun" }) {
//   return (
//     <header className="flex items-center justify-between px-6 md:px-10 py-4 bg-black/75 backdrop-blur-2xl border-b border-gray-800/60 shadow-2xl sticky top-0 z-50">
//       {/* Left: Greeting – exact style from reference */}
//       <div className="flex items-center gap-4">
//         <h1 className="text-xl md:text-2xl font-bold text-white tracking-tight">
//           Good morning, <span className="text-orange-400">{userName}</span> 👋
//         </h1>
//       </div>

//       {/* Right: Controls – exact layout & icons from reference */}
//       <div className="flex items-center gap-4 md:gap-6">
//         {/* Country / Language dropdown */}
//         <button className="flex items-center gap-2 px-4 py-2.5 bg-gray-900/70 rounded-full hover:bg-gray-800 transition text-gray-300 text-sm font-medium">
//           <span className="text-lg">🇺🇸</span>
//           <span>US</span>
//           <ChevronDown className="w-4 h-4 opacity-70" />
//         </button>

//         {/* Notification bell with badge */}
//         <button className="relative p-3 rounded-full bg-gray-900/70 hover:bg-gray-800 transition text-gray-300 hover:text-orange-300">
//           <Bell className="w-6 h-6" strokeWidth={2} />
//           <span className="absolute -top-1 -right-1 w-5 h-5 bg-red-500 text-white text-xs font-bold rounded-full flex items-center justify-center ring-2 ring-red-500/40">
//             2
//           </span>
//         </button>

//         {/* Search input (desktop) */}
//         <div className="relative hidden md:block">
//           <input
//             type="text"
//             placeholder="Search admins, organizations, tickets..."
//             className="w-80 pl-11 pr-5 py-3 bg-gray-800/70 border border-gray-700 rounded-xl text-white text-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-orange-500/50 transition-all"
//           />
//           <Search className="w-5 h-5 absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" />
//         </div>

//         {/* Mobile search icon */}
//         <button className="p-3 rounded-full bg-gray-900/70 hover:bg-gray-800 transition text-gray-300 hover:text-orange-300 md:hidden">
//           <Search className="w-6 h-6" />
//         </button>

//         {/* User avatar + name */}
//         <button className="flex items-center gap-3 hover:opacity-90 transition">
//           <div className="w-10 h-10 rounded-full bg-gradient-to-br from-orange-500 to-amber-600 flex items-center justify-center font-bold text-lg shadow-lg ring-2 ring-orange-500/40">
//             {userName?.[0]?.toUpperCase() || "A"}
//           </div>
//           <span className="hidden md:block font-medium text-white">{userName}</span>
//         </button>
//       </div>
//     </header>
//   );
// }


// // src/components/Header.jsx
// import { Bell, Search, Globe, ChevronDown, User } from "lucide-react";

// export default function Header({ name = "John Carter" }) {
//   return (
//     <header className="bg-bg-secondary/80 backdrop-blur-xl border-b border-gray-800/60 px-6 py-4 flex items-center justify-between sticky top-0 z-30">
//       <div className="flex items-center gap-10">
//         <div className="flex items-center gap-3">
//           <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-accent-orange-500 to-accent-orange-700 flex items-center justify-center">
//             <span className="text-white font-bold">S</span>
//           </div>
//           <h1 className="text-xl font-semibold">Dashboard</h1>
//         </div>
//       </div>

//       <div className="flex items-center gap-5">
//         <div className="flex items-center gap-2 px-4 py-2 bg-gray-800/60 rounded-full text-sm">
//           <Globe className="w-4 h-4" />
//           <span>US</span>
//           <ChevronDown className="w-4 h-4" />
//         </div>

//         <button className="relative p-2.5 hover:bg-gray-800/60 rounded-full transition">
//           <Bell className="w-5 h-5" />
//           <span className="absolute top-1 right-1 w-4 h-4 bg-red-500 rounded-full text-[10px] flex items-center justify-center font-bold">
//             2
//           </span>
//         </button>

//         <div className="flex items-center gap-3">
//           <div className="w-9 h-9 rounded-full bg-gradient-to-br from-accent-orange-500 to-amber-600 flex items-center justify-center font-bold text-white shadow-md">
//             {name[0]}
//           </div>
//           <span className="font-medium">{name}</span>
//         </div>
//       </div>
//     </header>
//   );
// }

// //src/components/Header.jsx
// import { Bell, Globe, ChevronDown } from 'lucide-react';
// import ThemeToggle from './ThemeToggle';

// export default function Header({ name = "Admin" }) {
//   return (
//     <header 
//       className="
//         bg-bg-dark dark:bg-bg-dark 
//         border-b border-accent-orange-900/30 
//         px-6 py-4 flex items-center justify-between 
//         sticky top-0 z-30 backdrop-blur-md
//       "
//     >
//       <div className="flex items-center gap-6">
//         <div className="flex items-center gap-3">
          
//           <h1 className="text-xl md:text-2xl font-bold text-text-white">
//             Dashboard
//           </h1>
//         </div>
//       </div>

//       <div className="flex items-center gap-4 md:gap-6">
//         {/* Country selector */}
//         <div className="flex items-center gap-2 px-4 py-2 bg-bg-card rounded-full text-sm border border-accent-orange-900/30">
//           <Globe className="w-4 h-4 text-accent-orange-400" />
//           <span>INR</span>
//           <ChevronDown className="w-4 h-4" />
//         </div>

//         {/* Notification */}
//         <button className="relative p-2.5 hover:bg-accent-orange-950/30 rounded-full transition">
//           <Bell className="w-5 h-5 text-text-white" />
//           <span className="absolute top-1 right-1 w-4 h-4 bg-loss-red rounded-full text-[10px] flex items-center justify-center font-bold">
//             2
//           </span>
//         </button>

//         {/* Theme Toggle */}
//         <ThemeToggle />

//         {/* User */}
//         <div className="flex items-center gap-3">
//           <div className="w-9 h-9 rounded-full bg-gradient-to-br from-accent-orange-600 to-accent-orange-800 flex items-center justify-center font-bold text-white shadow-md">
//             {name[0]}
//           </div>
//           <span className="font-medium hidden md:block">{name}</span>
//         </div>
//       </div>
//     </header>
//   );
// }

// // src/components/Header.jsx
// import { Bell, Globe, ChevronDown, LogOut } from 'lucide-react';
// import ThemeToggle from './ThemeToggle';

// export default function Header({ 
//   name = "Admin", 
//   onLogout 
// }) {
//   return (
//     <header 
//       className="
//         bg-bg-dark dark:bg-bg-dark 
//         border-b border-accent-orange-900/30 
//         px-6 py-4 flex items-center justify-between 
//         sticky top-0 z-30 backdrop-blur-md
//       "
//     >
//       <div className="flex items-center gap-6">
//         <div className="flex items-center gap-3">
//           <h1 className="text-xl md:text-2xl font-bold text-text-white">
//             Dashboard
//           </h1>
//         </div>
//       </div>

//       <div className="flex items-center gap-4 md:gap-6">
//         {/* Country selector */}
//         <div className="flex items-center gap-2 px-4 py-2 bg-bg-card rounded-full text-sm border border-accent-orange-900/30">
//           <Globe className="w-4 h-4 text-accent-orange-400" />
//           <span>INR</span>
//           <ChevronDown className="w-4 h-4" />
//         </div>

//         {/* Notification */}
//         <button className="relative p-2.5 hover:bg-accent-orange-950/30 rounded-full transition">
//           <Bell className="w-5 h-5 text-text-white" />
//           <span className="absolute top-1 right-1 w-4 h-4 bg-loss-red rounded-full text-[10px] flex items-center justify-center font-bold">
//             2
//           </span>
//         </button>

//         {/* Theme Toggle */}
//         <ThemeToggle />

//         {/* User Profile with Logout */}
//         <div className="relative group">
//           <div className="flex items-center gap-3 cursor-pointer">
//             <div className="w-9 h-9 rounded-full bg-gradient-to-br from-accent-orange-600 to-accent-orange-800 flex items-center justify-center font-bold text-white shadow-md">
//               {name[0]}
//             </div>
//             <div className="hidden md:block">
//               <span className="font-medium block">{name}</span>
//               <span className="text-xs text-secondary-text">Super Admin</span>
//             </div>
//             <ChevronDown className="w-4 h-4 text-secondary-text group-hover:text-accent-orange-400 transition" />
//           </div>

//           {/* Dropdown Menu */}
//           <div className="
//             absolute right-0 mt-2 w-56 bg-card-bg border border-card-border 
//             rounded-2xl shadow-2xl py-2 z-50
//             opacity-0 invisible group-hover:opacity-100 group-hover:visible
//             transition-all duration-200
//           ">
//             <div className="px-4 py-3 border-b border-card-border">
//               <p className="font-medium text-primary-text">{name}</p>
//               <p className="text-sm text-secondary-text">admin@onedesk.com</p>
//             </div>

//             <button
//               onClick={onLogout}
//               className="
//                 w-full flex items-center gap-3 px-4 py-3 
//                 hover:bg-accent-orange-950/50 text-loss-red 
//                 hover:text-red-400 transition-colors
//               "
//             >
//               <LogOut className="w-4 h-4" />
//               <span className="font-medium">Logout</span>
//             </button>
//           </div>
//         </div>
//       </div>
//     </header>
//   );
// }

// src/components/Header.jsx
import { Bell, Globe, ChevronDown, LogOut, Clock } from 'lucide-react';
import ThemeToggle from './ThemeToggle';
import { useState } from 'react';
import useOutsideClick from '../hooks/useOutsideClick';   // ← Import the hook

export default function Header({ 
  name = "Admin", 
  onLogout 
}) {
  const [showNotifications, setShowNotifications] = useState(false);
  const [showUserMenu, setShowUserMenu] = useState(false);

  // Static Notifications
  const notifications = [
    {
      id: 1,
      title: "New Super Admin Created",
      message: "Aarav Sharma was added as Super Admin",
      time: "2 min ago",
      type: "admin"
    },
    {
      id: 2,
      title: "Transaction Alert",
      message: "₹4,900 received from Career Mentorz",
      time: "15 min ago",
      type: "transaction"
    },
    {
      id: 3,
      title: "Organization Updated",
      message: "TechFlow Solutions updated their profile",
      time: "1 hour ago",
      type: "organization"
    },
  ];

  // Outside click handlers
  const notifRef = useOutsideClick(() => setShowNotifications(false));
  const userRef = useOutsideClick(() => setShowUserMenu(false));

  return (
    <header 
      className="
        bg-bg-dark dark:bg-bg-dark 
        border-b border-accent-orange-900/30 
        px-6 py-4 flex items-center justify-between 
        sticky top-0 z-30 backdrop-blur-md
      "
    >
      <div className="flex items-center gap-6">
        <div className="flex items-center gap-3">
          <h1 className="text-xl md:text-2xl font-bold text-text-white">
            Dashboard
          </h1>
        </div>
      </div>

      <div className="flex items-center gap-4 md:gap-6">
        {/* Country selector */}
        <div className="flex items-center gap-2 px-4 py-2 bg-bg-card rounded-full text-sm border border-accent-orange-900/30">
          <Globe className="w-4 h-4 text-accent-orange-400" />
          <span>INR</span>
          <ChevronDown className="w-4 h-4" />
        </div>

        {/* Notifications Dropdown */}
        <div className="relative" ref={notifRef}>
          <button 
            onClick={() => setShowNotifications(!showNotifications)}
            className="relative p-2.5 hover:bg-accent-orange-950/30 rounded-full transition"
          >
            <Bell className="w-5 h-5 text-text-white" />
            <span className="absolute top-1 right-1 w-4 h-4 bg-loss-red rounded-full text-[10px] flex items-center justify-center font-bold">
              {notifications.length}
            </span>
          </button>

          {/* Notification Dropdown */}
          {showNotifications && (
            <div className="
              absolute right-0 mt-3 w-80 bg-card-bg border border-card-border 
              rounded-2xl shadow-2xl z-50 overflow-hidden
            ">
              <div className="px-5 py-4 border-b border-card-border flex items-center justify-between bg-secondary-bg">
                <h3 className="font-semibold text-primary-text">Notifications</h3>
                <span className="text-xs px-2.5 py-1 bg-accent-orange-900/50 text-accent-orange-400 rounded-full">
                  {notifications.length} new
                </span>
              </div>

              <div className="max-h-[380px] overflow-y-auto">
                {notifications.map((notif) => (
                  <div 
                    key={notif.id}
                    className="px-5 py-4 border-b border-card-border hover:bg-accent-orange-950/30 transition-colors cursor-pointer"
                  >
                    <div className="flex gap-3">
                      <div className="mt-0.5">
                        <Clock className="w-4 h-4 text-accent-orange-400" />
                      </div>
                      <div className="flex-1">
                        <p className="font-medium text-primary-text text-sm">
                          {notif.title}
                        </p>
                        <p className="text-secondary-text text-sm mt-1">
                          {notif.message}
                        </p>
                        <p className="text-xs text-secondary-text mt-2">
                          {notif.time}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              <div className="p-4 border-t border-card-border text-center bg-secondary-bg">
                <button 
                  onClick={() => {
                    setShowNotifications(false);
                    alert("All notifications page coming soon...");
                  }}
                  className="text-accent-orange-400 hover:text-accent-orange-300 text-sm font-medium"
                >
                  View All Notifications
                </button>
              </div>
            </div>
          )}
        </div>

        {/* Theme Toggle */}
        <ThemeToggle />

        {/* User Menu with Logout */}
        <div className="relative" ref={userRef}>
          <button 
            onClick={() => setShowUserMenu(!showUserMenu)}
            className="flex items-center gap-3 cursor-pointer"
          >
            <div className="w-9 h-9 rounded-full bg-gradient-to-br from-accent-orange-600 to-accent-orange-800 flex items-center justify-center font-bold text-white shadow-md">
              {name[0]}
            </div>
            <div className="hidden md:block text-left">
              <span className="font-medium block text-text-white">{name}</span>
              <span className="text-xs text-secondary-text">Super Admin</span>
            </div>
            <ChevronDown className="w-4 h-4 text-secondary-text group-hover:text-accent-orange-400 transition" />
          </button>

          {/* User Dropdown */}
          {showUserMenu && (
            <div className="
              absolute right-0 mt-2 w-56 bg-card-bg border border-card-border 
              rounded-2xl shadow-2xl py-2 z-50
            ">
              <div className="px-4 py-3 border-b border-card-border">
                <p className="font-medium text-primary-text">{name}</p>
                <p className="text-sm text-secondary-text">admin@onedesk.com</p>
              </div>

              <button
                onClick={() => {
                  setShowUserMenu(false);
                  onLogout();
                }}
                className="
                  w-full flex items-center gap-3 px-4 py-3 
                  hover:bg-accent-orange-950/50 text-loss-red 
                  hover:text-red-400 transition-colors
                "
              >
                <LogOut className="w-4 h-4" />
                <span className="font-medium">Logout</span>
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}